import React from 'react';
import SiteSVG from '../../images/svg/icons/site.svg';
import GithubSVG from '../../images/svg/icons/github.svg';
import TwitterSVG from '../../images/svg/icons/twitter.svg';
import DribbbleSVG from '../../images/svg/icons/dribbble.svg';
import { FOOTER_LINKS } from '../../constants';
import './footer.scss';

const icons = {
  site: SiteSVG,
  github: GithubSVG,
  twitter: TwitterSVG,
  dribbble: DribbbleSVG,
};

function Footer() {
  return (
    <footer className="footer container">
      <div className="footer__inner">
        <p className="footer__section">
          Designed & developed by
          {' '}
          <a className="link" href="https://volti.dev">
            Ivan Volti
          </a>
          {' and '}
          <a className="link" href="https://github.com/voltidev/ember-svg-jar#-contributors">
            Contributors
          </a>
          .
        </p>

        <ul className="footer__social-list footer__section">
          {FOOTER_LINKS.map((link) => {
            const Icon = icons[link.id];

            return (
              <li
                className="footer__social-item"
                key={link.text}
              >
                <a
                  className="footer__social-link"
                  href={link.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.name}
                >
                  <Icon className="footer__social-icon" />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
